import { render } from "./UserSendEdit.vue?vue&type=template&id=2425ca4d"
import script from "./UserSendEdit.vue?vue&type=script&lang=js"
export * from "./UserSendEdit.vue?vue&type=script&lang=js"

import "./UserSendEdit.vue?vue&type=style&index=0&id=2425ca4d&lang=css"

import exportComponent from "/home/runner/work/Smart2Docs_Front-end/Smart2Docs_Front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__